/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `PENDING` - Pending
 * * `VIEWED` - Viewed
 * * `SIGNED` - Signed
 */
export enum SignatureParticipantStatusEnum {
    PENDING = 'PENDING',
    VIEWED = 'VIEWED',
    SIGNED = 'SIGNED',
}
